//import {StrictMode} from 'react'
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@mui/material';
import muiTheme from './application/theme/muiTheme.ts';
import '../i18n.ts';

createRoot(document.getElementById('root')!).render(
    //<StrictMode>
    <ThemeProvider theme={muiTheme}>
        <BrowserRouter
            future={{ v7_startTransition: true, v7_relativeSplatPath: true }}
        >
            <App />
        </BrowserRouter>
    </ThemeProvider>
    //</StrictMode>,
);
